<template>
  <div class="mw-form-v2-field" :class="classNameFromType(field.type)">
    <div v-if="hasLabel(field)" class="text-body2 mw-form-v2-label mw-form-v2-label-padding">
      <span v-html="field.label"></span>
      <OptionalLabel v-if="hasOptionalLabel(field)" :field="field"></OptionalLabel>
    </div>
    <div v-if="field.layout_description_on_top && hasDescription(field)" class="text-caption  mw-form-v2-description q-pl-none q-pt-none q-pb-sm" v-html="field.description"></div>
    <component
        :is="'f_' + (field.data_type_override ?  field.data_type_override : field.data_type)"
        v-model="fieldValue"
        :field="field"
        :class="'f_' + (field.data_type_override ?  field.data_type_override : field.data_type)"
    />
    <div v-if="!field.layout_description_on_top && hasDescription(field)" class="text-caption mw-form-v2-description" v-html="field.description"></div>
    <div v-if="hasSpace(field)" class="q-field__bottom row items-start">
      <div class="q-field__messages col"></div>
    </div>
  </div>

</template>

<script>
import {mapActions} from "vuex";
import field_components from "@/components/collection";
import {mapFields} from "vuex-map-fields";
//import {fieldsNoDescription} from "@/components/collection";
import {fieldsNoDescription, fieldsWithLabelInside} from "@/components/collection";
import OptionalLabel from "@/components/OptionalLabel";
import {fieldsNoAddedSpace} from "@/components/collection";

export default {
  props: {
    field: {},
  },
  data() {
    return {

    };
  },
  components: {
    ...field_components,
    OptionalLabel
  },
  methods: {
    ...mapActions({
      getFieldValue: 'values/list/getFieldValue',
      updateFieldValue: 'values/list/updateFieldValue',
    }),
    classNameFromType(type) {
      return 'field_' + type.replace('.','_').replace(' ','_').toLowerCase()
    },
    hasDescription (field) {
      const type = field.data_type_override ? field.data_type_override : field.data_type;
      return this.settings.theme.input.description &&  !fieldsNoDescription.includes(type) && field.description && field.description.trim();
    },
    hasSpace (field) {
      const type = field.data_type_override ? field.data_type_override : field.data_type;
      return !field.required && !fieldsNoAddedSpace.includes(type);
    },
    hasOptionalLabel (field) {
      const type = field.data_type_override ? field.data_type_override : field.data_type;
      return fieldsWithLabelInside.includes(type);
    },
    hasLabel (field) {
      const type = field.data_type_override ? field.data_type_override : field.data_type;
      //return (this.settings.theme.input.label || field.layout_show_label) && !fieldsWithLabelInside.includes(type) && field.label && field.label.trim();
      let visible = this.settings.theme.input.label;
      if(this.settings.theme.input.label === true && field.layout_show_label === true)  {
        visible = false;
      }
      if(this.settings.theme.input.label === false && field.layout_show_label === true && !fieldsWithLabelInside.includes(type))  {
        visible = true;
      }
      if(this.settings.theme.input.label === false && !field.layout_show_label && fieldsWithLabelInside.includes(type))  {
        visible = true;
      }


      return visible && field.label && field.label.trim();
    }
  },
  computed: {
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    fieldValue: {
      get() {
        return this.fieldValues[this.field.id];
      },
      set(value) {
        this.updateFieldValue({fieldSettings: this.field, fieldValue: value})
      },
    }
  },
  mounted() {

  }
}
</script>
<style>
.mw-form-v2-description {
  padding: 8px 12px 0;
}

.mw-form-v2-label-padding {
  padding: 0 8px 12px 0;
}
</style>
